export interface Listener<T> {
   (data: T): void;
}

export class ListenerList<T> {
   listeners: Listener<T>[] = [];

   addListener(listener: Listener<T>) {
      this.listeners.push(listener);
   }

   removeListener(listener: Listener<T>) {
      this.listeners = this.listeners.filter(item => item !== listener);
   }

   hasListener(listener: Listener<T>) {
      return !!this.listeners.find(item => item === listener);
   }

   isEmpty() {
      return this.listeners.length === 0;
   }

   notifyListeners(data: T) {
      this.listeners.forEach((listener) => {
         listener(data);
      });
   }
}
